import React from 'react'
import clsx from 'clsx'
import { useInfiniteLoaderStyles as useStyles } from './styles'
import LoadingSpinner from '../../../../atoms/LoadingSpinner'

const InfiniteLoaderNavButtons = React.memo(
  ({ isSmall, disabled, loadMore, isLoading }) => {
    const classes = useStyles({ isSmall })

    return (
      <>
        {!disabled && (
          <div className={classes.root}>
            <button
              className={clsx(
                (disabled || isLoading) && classes.disabled,
                classes.text
              )}
              onClick={loadMore}
              disabled={isLoading}
            >
              LOAD MORE
            </button>
            {isLoading && <LoadingSpinner className={classes.spinner} />}
          </div>
        )}
      </>
    )
  }
)

export default InfiniteLoaderNavButtons
